import { render, staticRenderFns } from "./ManageRolesModal.vue?vue&type=template&id=ed96f3de&scoped=true"
import script from "./ManageRolesModal.vue?vue&type=script&lang=js"
export * from "./ManageRolesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed96f3de",
  null
  
)

export default component.exports